import { render, staticRenderFns } from "./FilterContacts.vue?vue&type=template&id=056e161b&scoped=true"
import script from "./FilterContacts.vue?vue&type=script&lang=js"
export * from "./FilterContacts.vue?vue&type=script&lang=js"
import style0 from "./FilterContacts.vue?vue&type=style&index=0&id=056e161b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056e161b",
  null
  
)

export default component.exports